const energyUnits = {
    j: {
      kWh: 2.77777778e-7,
      MWh: 2.77777778e-10,
      BTU: 0.000947817,
      mmBTU: 9.47817e-7,
      l: 0.001,
    m3: 1e-6,
    gj: 1e-9,
    },
    // ... otros objetos de unidad
    kWh: {
      j: 3600000,
      MWh: 0.001,
      BTU: 3412.142,
      mmBTU: 3.412142, 
      l: 3600,
      m3: 3600,
      gj: 3.6,
    },
    MWh: {
      j: 3.6e+9,
      kWh: 1000,
      BTU: 3.412e+6,
      mmBTU: 3.412142,
      "l": 3600000,
      "m3": 3600000,
      "gj": 3600,
    },
    BTU: {
      j: 1055.055853,
      kWh: 0.000293071,
      MWh: 2.93071e-7,
      mmBTU: 1.0E-6,
      l: 1055.056,
      m3: 0.001055056,
      gj: 0.000001055056,
      "MWh": 2.928e-7
    },
    mmBTU: {
      j: 1055.06,
      kWh: 293.07107,
      MWh: 0.293071,
      mmBTU: 1000000,
      l: 1055056,
      m3: 1055.056,
    gj: 1.055056,
    "MWh": 0.2928
    },
    l:{
      m3: 0.001,
      gj: 0.0000036,
      BTU: 0.000947817,
      mmbtu: 9.47817e-8,
      j: 1000,
      kWh: 0.0002777778,
      MWh: 2.77778e-7
    },
    m3: {
    l: 1000,
    gj: 0.0036,
    btu: 947.817,
    mmbtu: 9.47817e-5,
    J: 1000000,
    kWh: 0.2777778,
    MWh: 0.0002777778
  },
  gj: {
    l: 277777.7778,
    m3: 277.7777778,
    btu: 947817.12,
    mmbtu: 0.000947817,
    J: 1000000000,
    kWh: 277.7777778,
    "MWh": 0.277777778
  },
    // ... otros objetos de unidad
    // ...
  };

  const energyUnitsConvert={
    "l": {
      "m3": 0.001, 
      "gj": 0.0000036, //
      "btu": 0.000947817, //
      "mmbtu": 9.47817e-8, //
      "J": 1000, //
      "kWh": 0.0002777778, //
      "MWh": 2.77778e-7, //
      "us_gallons": 0.264172,
      "ton_metrica": 0.001,//
      "ton_corta": 0.00110231, //
      "oz": 33.814,
      "MJ": 0.000001,//
      "lb": 2.20462,
      "kg": 0.001, //
      "g": 1,//
      "galon": 0.264172,
      "kWh_termico": 1
    },
    "m3": {
      "l": 1000,
      "gj": 0.0036,//
      "btu": 947.817,//
      "mmbtu": 9.47817e-5,//
      "J": 1000000,//
      "kWh": 0.2777778,//
      "MWh":  0.0105,//
      "us_gallons": 264.172,
      "ton_metrica": 1,//
      "ton_corta": 1.10231,//
      "oz": 33814,
      "MJ": 0.0001,//
      "lb": 2.20462,//
      "kg": 1,//
      "g": 1000,//
      "galon": 219.969
    },
    "gj": {
      "l": 277777.7778,//
      "m3": 277.7777778,//
      "btu": 947817,
      "mmbtu": 0.000947817,
      "J": 1e+9,
      "kWh": 277.778,
      "MWh": 0.277777778,
      "us_gallons": 694.44,//
      "ton_metrica": 0.2777777778,//
      "ton_corta": 0.305711,//
      "oz": 10.28234,//
      "MJ": 1,
      "lb": 0.453592,//
      "kg": 0.2777777778,//
      "g": 277777.7778,//
      "galon": 694.44//
    },
    "btu": {
      "l": 1055.056,//
      "m3": 0.001055056,//
      "gj": 0.000001055056,
      "mmbtu": 1.055056e-6,
      "J": 1055.06,
      "kWh": 0.000293071,
      "MWh": 2.928e-7,
      "us_gallons": 0.000278,//
      "ton_metrica": 0.000278,//
      "ton_corta": 0.000307,//
      "oz": 0.010607,//
      "MJ": 0.000001055,//
      "lb": 0.002393,//
      "kg": 0.000278,//
      "g": 1.055056,//
      "galon": 0.000278//
    },
    "mmbtu": {
      "l": 1055056,
      "m3": 1055.056,
      "gj": 1.055056,
      "btu": 1000000,
      "J": 1055056000,
      "kWh": 292.8,
      "MWh": 0.2928,
      "us_gallons": 278.017,
      "ton_metrica": 0.2928,
      "ton_corta": 0.3228,
      "oz": 11.3817,
      "MJ": 0.001055056,
      "lb": 2.0468,
      "kg": 0.2928,
      "g": 292.8,
      "galon": 278.017
    },
    "J": {
      "l": 0.001,
      "m3": 1e-6,
      "gj": 1e-9,
      "btu": 0.000947817,
      "mmbtu": 9.47817e-10,
      "kWh": 2.77778e-7,
      "MWh": 2.77778e-10,
      "us_gallons": 2.64172e-4,
      "ton_metrica": 2.77778e-7,
      "ton_corta": 3.30517e-7,
      "oz": 9.9303e-6,
      "MJ": 1e-6,
      "lb": 2.20462e-6,
      "kg": 2.77778e-7,
      "g": 2.77778e-4,
      "galon": 2.64172e-4
    },
    "kWh": {
      "l": 3600,
      "m3": 3600,
      "gj": 3.6,
      "btu": 3412.142,
      "mmbtu": 0.003412142,
      "J": 3600000,
      "MWh": 0.001,
      "us_gallons": 0.946353,
      "ton_metrica": 0.001,
      "ton_corta": 0.00110231,
      "oz": 0.03527396,
      "MJ": 0.000001,
      "lb": 0.00220462,
      "kg": 0.001,
      "g": 1,
      "galon": 0.946353
    },
    "MWh": {
      "l": 3600000,
      "m3": 3600000,
      "gj": 3600,
      "btu": 3412142,
      "mmbtu": 3.412142,
      "J": 3600000000,
      "kWh": 1000,
      "us_gallons": 946.353,
      "ton_metrica": 1,
      "ton_corta": 1.10231,
      "oz": 35.27396,
      "MJ": 0.0001,
      "lb": 2204.62,
      "kg": 1,
      "g": 1000,
      "galon": 946.353
    },
    "us_gallons": {
      "l": 3.78541,
      "m3": 0.00378541,
      "gj": 1.36e-5,
      "btu": 3.41214,
      "mmbtu": 3.41214e-6,
      "J": 3785.41,
      "kWh": 0.000264172,
      "MWh": 2.64172e-7,
      "ton_metrica": 0.000264172,
      "ton_corta": 0.000291,
      "oz": 0.010607,
      "MJ": 1.36e-5,
      "lb": 0.0083454,
      "kg": 0.000264172,
      "g": 3.78541,
      "galon": 1
    },
    "ton_metrica": {
      "l": 1000,
      "m3": 1,
      "gj": 3.6,
      "btu": 3412.142,
      "mmbtu": 0.003412142,
      "J": 1000000,
      "kWh": 0.2777778,
      "MWh": 0.0002777778,
      "us_gallons": 264.172,
      "ton_corta": 1.10231,
      "oz": 35.27396,
      "MJ": 0.0001,
      "lb": 2204.62,
      "kg": 1000,
      "g": 1000000,
      "galon": 264.172
    },
    "ton_corta": {
      "l": 907.18474,
      "m3": 0.90718474,
      "gj": 3.26,
      "btu": 2955.928,
      "mmbtu": 0.002955928,
      "J": 907184.74,
      "kWh": 0.251657,
      "MWh": 0.000251657,
      "us_gallons": 240.717,
      "ton_metrica": 0.90718474,
      "oz": 31.9608,
      "MJ": 0.00090718474,
      "lb": 2000,
      "kg": 907.18474,
      "g": 907184.74,
      "galon": 240.717
    },
    "oz": {
      "l": 0.0295735,//
      "m3": 2.95735e-5,//
      "gj": 1.05506e-8,//
      "btu": 0.03527396,//
      "mmbtu": 3.527396e-8,//
      "J": 28.3495,//
      "kWh": 7.93675e-6,//
      "MWh": 7.93675e-9,//
      "us_gallons": 0.03125,//
      "ton_metrica": 2.835e-5,
      "ton_corta": 3.125e-5,
      "MJ": 0.00003527396,//
      "lb": 0.0625,
      "kg": 0.0283495,
      "g": 28.3495,
      "galon": 0.03125//
    },
    "kWh_termico": {
      "l": 3600,
      "m3": 3600,
      "gj": 3.6,
      "btu": 3412.142,
      "mmbtu": 0.003412142,
      "J": 3600000,
      "MWh": 0.001,
      "us_gallons": 0.946353,
      "ton_metrica": 0.001,
      "ton_corta": 0.00110231,
      "oz": 0.03527396,
      "MJ": 0.000001,
      "lb": 0.00220462,
      "kg": 0.001,
      "g": 1,
      "galon": 0.946353,
      "kWh":1
  }
}

  const emissionsUnitsConvert={
  "ppm": {
    "mg_m3": 1,
    "µg_m3": 1000,
    "ng_m3": 1000000,
    "g_s": 1e-6,
    "kg_h": 3.6e-4,
    "m3_h": 1e-6,
    "l_min": 1e-3,
    "m3_s": 1.6667e-8,
    "percent_vol": 1e-6,
    "mg": 1,
    "m3": 1e-6,
    "µg": 1000,
    "ng": 1000000,
    "g": 1e-3,
    "s": 1,
    "kg": 1e-6,
    "l": 1e-3
  },
  "mg_m3": {
    "ppm": 1,
    "µg_m3": 1000,
    "ng_m3": 1000000,
    "g_s": 1e-3,
    "kg_h": 3.6,
    "m3_h": 1e-3,
    "l_min": 1e-2,
    "m3_s": 1.6667e-7,
    "percent_vol": 1e-5,
    "mg": 1,
    "m3": 1e-3,
    "µg": 1000,
    "ng": 1000000,
    "g": 1e-3,
    "s": 1e-3,
    "kg": 1e-6,
    "l": 1e-2
  },
  "µg_m3": {
    "ppm": 0.001,
    "mg_m3": 0.001,
    "ng_m3": 1000,
    "g_s": 1e-6,
    "kg_h": 3.6e-4,
    "m3_h": 1e-6,
    "l_min": 1e-5,
    "m3_s": 1.6667e-8,
    "percent_vol": 1e-8,
    "mg": 0.001,
    "m3": 1e-6,
    "µg": 1,
    "ng": 1000,
    "g": 1e-6,
    "s": 1e-6,
    "kg": 1e-9,
    "l": 1e-5
  },
  "ng_m3": {
    "ppm": 0.000001,
    "mg_m3": 0.000001,
    "µg_m3": 0.001,
    "g_s": 1e-9,
    "kg_h": 3.6e-7,
    "m3_h": 1e-9,
    "l_min": 1e-8,
    "m3_s": 1.6667e-10,
    "percent_vol": 1e-11,
    "mg": 0.000001,
    "m3": 1e-9,
    "µg": 0.001,
    "ng": 1,
    "g": 1e-9,
    "s": 1e-9,
    "kg": 1e-12,
    "l": 1e-8
  },
  "g_s": {
    "ppm": 1000000,
    "mg_m3": 1000,
    "µg_m3": 1000000,
    "ng_m3": 1000000000,
    "kg_h": 3600,
    "m3_h": 3600,
    "l_min": 60,
    "m3_s": 1.6667e-3,
    "percent_vol": 0.01,
    "mg": 1000,
    "m3": 1,
    "µg": 1000000,
    "ng": 1000000000,
    "g": 1,
    "s": 1,
    "kg": 0.001,
    "l": 1000
  },
  "kg_h": {
    "ppm": 1000000,
    "mg_m3": 1000,
    "µg_m3": 1000000,
    "ng_m3": 1000000000,
    "g_s": 0.000277778,
    "m3_h": 1,
    "l_min": 16.6667,
    "m3_s": 2.7778e-5,
    "percent_vol": 0.00001,
    "mg": 1000,
    "m3": 1,
    "µg": 1000000,
    "ng": 1000000000,
    "g": 1,
    "s": 1,
    "kg": 1,
    "l": 1000
  },
  "m3_h": {
    "ppm": 1000000,
    "mg_m3": 1000,
    "µg_m3": 1000000,
    "ng_m3": 1000000000,
    "g_s": 1,
    "kg_h": 1,
    "l_min": 16.6667,
    "m3_s": 1/3600,
    "percent_vol": 1,
    "mg": 1000000,
    "m3": 1,
    "µg": 1000000000,
    "ng": 1000000000000,
    "g": 1000,
    "s": 3600,
    "kg": 1000,
    "l": 1000000
  },
  "l_min": {
    "ppm": 1000000,
    "mg_m3": 1000,
    "µg_m3": 1000000,
    "ng_m3": 1000000000,
    "g_s": 1,
    "kg_h": 60,
    "m3_h": 60,
    "m3_s": 1/60,
    "percent_vol": 0.01,
    "mg": 1000,
    "m3": 1,
    "µg": 1000000,
    "ng": 1000000000,
    "g": 1,
    "s": 60,
    "kg": 1,
    "l": 1
  },
  "m3_s": {
    "ppm": 60000000,
    "mg_m3": 6000,
    "µg_m3": 6000000,
    "ng_m3": 6000000000,
    "g_s": 600,
    "kg_h": 2160000,
    "m3_h": 3600,
    "l_min": 3600,
    "percent_vol": 0.6,
    "mg": 6000,
    "m3": 6,
    "µg": 6000000,
    "ng": 6000000000,
    "g": 6,
    "s": 1,
    "kg": 6,
    "l": 6000
  },
  "percent_vol": {
    "ppm": 1000000,
    "mg_m3": 100000000,
    "µg_m3": 100000000000,
    "ng_m3": 100000000000000,
    "g_s": 100,
    "kg_h": 100000,
    "m3_h": 100,
    "l_min": 1,
    "m3_s": 0.01,
    "mg": 100000,
    "m3": 1,
    "µg": 100000000000,
    "ng": 100000000000000,
    "g": 100,
    "s": 1,
    "kg": 100,
    "l": 1
  },
  "mg": {
    "ppm": 1000,
    "mg_m3": 1,
    "µg_m3": 1000,
    "ng_m3": 1000000,
    "g_s": 0.001,
    "kg_h": 0.0036,
    "m3_h": 0.001,
    "l_min": 0.01,
    "m3_s": 1.6667e-6,
    "percent_vol": 0.0001,
    "mg": 1,
    "m3": 1e-3,
    "µg": 1000,
    "ng": 1000000,
    "g": 0.001,
    "s": 1e-3,
    "kg": 1e-6,
    "l": 0.01
  },
  "m3": {
    "ppm": 1000000,
    "mg_m3": 1000,
    "µg_m3": 1000000,
    "ng_m3": 1000000000,
    "g_s": 1,
    "kg_h": 3600,
    "m3_h": 1,
    "l_min": 60,
    "m3_s": 1,
    "percent_vol": 1,
    "mg": 1000000,
    "m3": 1,
    "µg": 1000000000,
    "ng": 1000000000000,
    "g": 1000,
    "s": 3600,
    "kg": 1000,
    "l": 1000
  }
}

  
  export function convertEnergy(value, fromUnit, toUnit, selectedUnits) {
    const from = fromUnit?.toLowerCase?.() ?? fromUnit;
    const to = toUnit?.toLowerCase?.() ?? toUnit;
    if (!energyUnitsConvert[from] || !energyUnitsConvert[from][to]) {
      //throw new Error(`Conversión no válida: ${fromUnit} a ${toUnit}`);
      return value;
    }
    const result = value * energyUnitsConvert[from][to];
    return result ;
  }


